// Where i18next-http-backend fetches a language file from.
//
// The base path is the backend's own default ('/locales/{{lng}}/{{ns}}.json',
// pinned by the test against node_modules). With a build id (CI sets
// REACT_APP_BUILD_ID to the commit sha in both workflow ymls) every deploy
// gets its own URL - '.../translation.json?v=<sha>' - so a browser or proxy
// that kept the previous deploy's translation.json can never answer for the
// new bundle: a key that is new in this deploy would otherwise fall back to
// English on that machine until the cached copy expired (the 11/9 report).
// The server ignores the query string (server.js resolves the path before
// the '?'), so the file served is the same; only the cache key changes.
//
// Known limits. ?v= is a key for the caches BETWEEN the browser and server.js
// (a heuristically cached copy, a proxy, Front Door) - and only for caches
// that key on the query string (Front Door with "ignore query string" would
// defeat it; today it is CONFIG_NOCACHE). It does not reach server.js' own
// in-memory file cache (loadFile keeps each file by path, taken after the '?'
// is stripped). That cache cannot produce "new keys shown in English" on its
// own, though: it keeps index.html the same way, so a process that was not
// restarted would serve the OLD bundle (without the new keys) next to the old
// json. Stale json next to a NEW bundle needs a copy cached outside server.js
// - exactly what ?v= rules out. After a deploy, 'curl .../locales/en/
// translation.json' (no ?v) showing the new keys proves the restart happened.
//
// Without a build id (local builds, an unset yml) the path IS the backend
// default - the request the app has always made.
export const DEFAULT_LOCALES_LOAD_PATH = '/locales/{{lng}}/{{ns}}.json'

export function buildLocalesLoadPath (buildId: string | null | undefined): string {
  const id = (buildId ?? '').trim()
  if (id === '') return DEFAULT_LOCALES_LOAD_PATH
  return `${DEFAULT_LOCALES_LOAD_PATH}?v=${encodeURIComponent(id)}`
}
